import { AutoComplete, Input, Spin } from "antd";

// Combobox de búsqueda remota sobre <AutoComplete> de antd.
// Props:
//   value            texto actual del input
//   onChange(text)   se dispara al teclear
//   onSearch(text)   se dispara (ya debounced por el caller si aplica) para pedir opciones al backend
//   options          [{ value, label }]  (label opcional, si no se usa value)
//   loading          booleano: muestra spinner + "Buscando..."
//   onSelect(option) se dispara al elegir una opción del menú
//   placeholder, disabled, size, className, inputClassName
export default function SearchCombobox({
  value,
  onChange,
  onSearch,
  options = [],
  loading = false,
  onSelect,
  placeholder,
  disabled,
  size,
  className = "",
  inputClassName = "",
  notFoundContent = "Sin resultados",
  autoFocus,
}) {
  const antdOptions = options.map((opt) => ({ value: String(opt.value), label: opt.label ?? opt.value, __raw: opt }));

  return (
    <AutoComplete
      className={className}
      style={{ width: "100%" }}
      value={value ?? ""}
      options={antdOptions}
      disabled={disabled}
      onChange={(text) => {
        onChange?.(text);
        onSearch?.(text);
      }}
      onSelect={(_, option) => onSelect?.(option.__raw ?? { value: option.value, label: option.label })}
      notFoundContent={loading ? <Spin size="small" /> : notFoundContent}
      popupMatchSelectWidth
    >
      <Input placeholder={placeholder} size={size} className={inputClassName} autoFocus={autoFocus} autoComplete="off" />
    </AutoComplete>
  );
}
